module.exports = __webpack_public_path__ + "img/partner_lp_bnr_01.894503ce.jpg";